import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import customerIcon from '../../img/customer.svg';
import translate from '../../lib/i18n/translate'

import './CustomerHeader.css'

const iconStyles = {
  fontSize: '2.4rem',
  color: LoomisColors.white,
};

export const CustomerHeader = ({customer, showMap, branchCount, openExportDialog, strings}) => {
	const {ShowOnMap, Branches, Branch, ExportTransactions} = strings;
    return (
        <div className="CustomerHeader">
        	
	        	<Row middle="xs">
	                <Col xs={4} sm={4} md={4} lg={4} >
                    
			            <div className="CustomerIcon">
			            	<img src={customerIcon} alt="Loomis"/>
			            </div>
			            <div className="CustomerName">{customer.name}</div>
			            <div className="CustomerAddress">{customer.adress1}, {customer.adress2}</div>
	                </Col>
	                <Col xs={8} sm={8} md={8} lg={8} >
						<FontIcon className="CustomerExportTransactionsIcon material-icons" style={iconStyles} onClick={()=>openExportDialog()}>file_download</FontIcon>
						<div className="CustomerExportTransactions" onClick={()=>openExportDialog()}>{ExportTransactions}</div>
			            <FontIcon className="CustomerMapIcon material-icons" style={iconStyles} onClick={()=>showMap()}>place</FontIcon>
						<div className="CustomerMap" onClick={()=>showMap()}>{ShowOnMap}</div>
	                	<div className="CustomerBranchCount">{branchCount} {branchCount > 1?Branches:Branch}</div>
	                </Col>
	        	</Row>
        </div>
    );
};

CustomerHeader.propTypes = {
    customer: PropTypes.object.isRequired,
};

export default translate('CustomerHeader')(CustomerHeader);



// WEBPACK FOOTER //
// ./src/components/customer/CustomerHeader.js